<template>
  <Timeline
    :title="$t('nav.twkn')"
    :timeline="timeline"
    :timeline-name="'publicAndExternal'"
  />
</template>

<script src="./public_and_external_timeline.js"></script>
